import { render } from "./AddEditAddress.vue?vue&type=template&id=983c3454"
import script from "./AddEditAddress.vue?vue&type=script&lang=js"
export * from "./AddEditAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__